<template>
  <b-form @submit.prevent="onSubmit">
    <b-card-header
        class="v3_box_teal_header v3_color_black_knight"
    >
      <b-row>
        <b-col sm="12" md="6" class="align-self-center text-center-mobile">
          <span class="v3_color_teal text-uppercase font_weight_bold text-sm-center">
            {{ user.email }}
          </span>
        </b-col>
        <b-col
            sm="12"
            md="6"
            class="d-flex align-items-center justify-content-end mobile-buttons-profile"
        >
          <b-button type="submit" variant="v3_teal_outline">
            <template v-if="!saveLoading">
              <template v-if="!isHeaderVisible">Save & Next</template>
              <template v-else>Save</template>
            </template>
            <template v-else>
              <b-spinner small/>
              <span class="ml-1">Saving...</span>
            </template>
          </b-button>
          <b-button variant="v3_teal_outline" class="ml-3" @click="cancel">
            Cancel
          </b-button>
        </b-col>
      </b-row>
    </b-card-header>
    <b-card-body class="v3_box_teal_body p-4 p-sm-2">
      <div class="grey-box">
        <div class="border_1 border_grey p-3">
          <b-row>
            <b-col>
              
              <b-form-group
                  label-cols-sm="6"
                  label-cols-lg="5"
                  :label="this.isFieldRequiredByMembership('ethnicity') ? 'Ethnicity:' : 'Ethnicity (optional):'"
                  label-class="v3_color_teal d-flex align-items-center"
                  v-if="fromPriorStudy && userEthnicity"
              >
                <div class="phairify-select-wrapper">
                  <b-form-select
                      
                      v-model="ethnicity"
                      class="rounded_0 border_grey"
                      :options="$store.state.ethnicityOptions"
                      :state="validateState('ethnicity')"
                  >
                    <template slot="first">
                      <option :value="null" disabled>
                        -- Select --
                      </option>
                    </template>
                  </b-form-select>
                </div>
                <div
                    v-show="$v.ethnicity.$anyError"
                    tabindex="-1"
                    role="alert"
                    aria-live="assertive"
                    aria-atomic="true"
                    class="invalid-feedback"
                >
                  {{ invalidFeedback.ethnicity }}
                </div>
              </b-form-group>
              
              <force-update-behaviour v-if="fromPriorStudy && userZipcode">
                <template slot-scope="{ keyId, keyUpdater }">
                  <b-form-group
                      label-cols-sm="6"
                      label-cols-lg="5"
                      :label="isFieldRequiredByMembership('practice_zip') ? 'Practice ZIP Code:' : 'Practice ZIP Code:'"
                      label-class="v3_color_teal d-flex align-items-center"
                  >
                    <b-form-input
                        ref="zipInput"
                        :key="keyId"
                        :value="$v.zip.$model"
                        @input="onZipInput($event, keyUpdater)"
                        class="p-3 rounded_0 border_grey height_auto v3_color_black_knight"
                        v-model="zip"
                        :state="validateState('zip')"
                    >
                    </b-form-input>
                    <div
                        v-show="$v.zip.$anyError"
                        tabindex="-1"
                        role="alert"
                        aria-live="assertive"
                        aria-atomic="true"
                        class="invalid-feedback"
                    >
                      {{ invalidFeedback.zip }}
                    </div>
                  </b-form-group>
                </template>
              </force-update-behaviour>
              
              <b-form-group
                  label="Visa status:"
                  label-cols-sm="6"
                  label-cols-lg="5"
                  label-class="v3_color_teal d-flex align-items-center"
                  v-if="fromPriorStudy && userVisaStatus"
              >
                <div class="phairify-select-wrapper">
                  <b-form-select
                      v-model="$v.visaStatus.$model"
                      class="rounded_0 border_grey v3_color_black_knight"
                      :options="visaStatusOptions"
                      :state="validateState('visaStatus')"
                  />
                </div>
                <div
                    v-show="$v.visaStatus.$anyError"
                    tabindex="-1"
                    role="alert"
                    aria-live="assertive"
                    aria-atomic="true"
                    class="invalid-feedback"
                >
                  {{ invalidFeedback.visaStatus }}
                </div>
              </b-form-group>
              <b-form-group
                  v-if="isFieldSupported('boardCertifications') && fromPriorStudy && userBoardCertification"
              >
                <user-profile-board-certification-list
                    :certifications="boardCertifications"
                    :excluded-certification-ids="excludedCertificationIds"
                    :has-board-certification="hasBoardCertification"
                    :has-board-certification-label="'I am currently either Board Certified or Board Eligible'"
                    :society-id="parseInt(societyId)"
                    @addBoardCertification="onAddBoardCertification"
                    @update-has-board-certification="onUpdateHasBoardCertification"
                />

                <div
                    v-show="$v.boardCertifications.$anyError"
                    tabindex="-1"
                    role="alert"
                    aria-live="assertive"
                    aria-atomic="true"
                    class="invalid-feedback"
                >
                  {{ invalidFeedback.boardCertifications }}
                </div>
              </b-form-group>
              <b-form-group
                  label="State of License(s)"
                  label-cols-sm="6"
                  label-cols-lg="5"
                  label-class="v3_color_teal d-flex align-items-center"
                  v-if="fromPriorStudy && userStateOfLicense"
              >
                <div class="phairify-select-wrapper">
                  <b-form-select
                      multiple
                      v-model="$v.licensedStates.$model"
                      class="rounded_0 border_grey v3_color_black_knight"
                      :options="getStateOptions"
                      :state="validateState('licensedStates')"
                  />
                </div>
                <div
                    v-show="$v.licensedStates.$anyError"
                    tabindex="-1"
                    role="alert"
                    aria-live="assertive"
                    aria-atomic="true"
                    class="invalid-feedback"
                >
                  {{ invalidFeedback.licensedStates }}
                </div>
              </b-form-group>
            </b-col>
          </b-row>
        </div>
      </div>
    </b-card-body>
  </b-form>
</template>

<script>
import {validationMixin} from 'vuelidate';
import {
  required,
  minLength,
  maxLength,
  numeric,
} from 'vuelidate/lib/validators';
import UserProfileBoardCertificationList
  from '@/components/users/profile/BoardCertification/UserProfileBoardCertificationList';
import {VISA_STATUSES_LABELS, VISA_STATUSES_TYPES} from '@/store';
import GetMemberTypeMappingOptionsMixin from '@/mixins/GetMemberTypeMappingOptionsMixin';
import ForceUpdateBehaviour from '@/behaviours/ForceUpdateBehaviour';
import EthnicityNaMixin from "@/mixins/EthnicityNaMixin";
import states from '@/providers/States.js';

export default {
  name: 'UpdateUserProfileMssUserForm',
  mixins: [
    validationMixin,
    GetMemberTypeMappingOptionsMixin,
    EthnicityNaMixin,
  ],
  components: {
    UserProfileBoardCertificationList,
    ForceUpdateBehaviour,
  },
  props: {
    saveLoading: {
      type: Boolean,
      default: false,
    },
    isHeaderVisible: {
      type: Boolean,
      default: true,
    },
    fromPriorStudy: Boolean,
    selectedProfileQuestions: Array
  },
  data: function () {
    const user = this.$store.state.user || {};
    return {
      username: user.username || null,
      specialtyId: user.specialty_id || null,
      subspecialtyId: user.subspecialty_id || null,
      visaStatus: user.visa_status || VISA_STATUSES_TYPES.US_CITIZEN,
      ethnicity: user.ethnicity && Array.isArray(user.ethnicity) ? user.ethnicity[0] : [],
      licensedStates: user.licensed_states || [],
      genderIdentity: user.gender_identity || null,
      zip: user.practice_zip || null,
      hasBoardCertification: parseInt(user.has_board_certification) || 0,
      boardCertifications: [...user.boardCertifications] || [],
    };
  },
  validations: function () {
    const validations = {
      visaStatus: {},
      zip: {
        required,
        numeric,
        minLength: minLength(5),
        maxLength: maxLength(5),
      },
      boardCertifications: {},
      ethnicity: {},
      licensedStates : {required},
    };
    if (this.isFieldSupported('practice_zip')) {
      validations.zip = {
        minLength: minLength(5),
        maxLength: maxLength(5),
        numeric,
      };
      if (this.isFieldRequiredByMembership('practice_zip')) {
        validations.zip.required = required;
      }
    }
    if (
        this.hasBoardCertification &&
        this.isFieldSupported('boardCertifications') &&
        this.isFieldRequiredByMembership('boardCertifications')
    ) {
      validations.boardCertifications = {
        required,
      };
    }
    if (
        this.isFieldSupported('visa_status') &&
        this.isFieldRequiredByMembership('visa_status')
    ) {
      validations.visaStatus = {
        required,
      };
    }
    if (
        this.isFieldSupported('ethnicity') &&
        this.isFieldRequiredByMembership('ethnicity')
    ) {
      validations.ethnicity = {
        required,
      };
    }
    return validations;
  },
  // created: function () {
  //   this.setDefaultSpecialty();
  // },
  computed: {
    user: function () {
      return this.$store.state.user ? this.$store.state.user : {};
    },
    userEthnicity: function () {
      return this.selectedProfileQuestions ? (this.selectedProfileQuestions.includes("userEthnicity") ? true : false) : false
    },
    userVisaStatus: function () {
      return this.selectedProfileQuestions ? (this.selectedProfileQuestions.includes("userVisaStatus") ? true : false) : false
    },
    userZipcode: function () {
      return this.selectedProfileQuestions ? (this.selectedProfileQuestions.includes("userZipcode") ? true : false) : false
    },
    userBoardCertification: function () {
      return this.selectedProfileQuestions ? (this.selectedProfileQuestions.includes("userBoardCertification") ? true : false) : false
    },
    userStateOfLicense : function (){
      return this.selectedProfileQuestions ? (this.selectedProfileQuestions.includes("licensedStates") ? true : false) : false
    },
    invalidFeedback: function () {
      return {
        // zip: !this.$v.zip.numeric
        //     ? 'Should contain only numbers'
        //     : !this.$v.zip.minLength || !this.$v.zip.maxLength
        //         ? 'Zip code should be 5 characters long'
        //         : 'This field is required',
          zip: this.$v.zip.$pending
          ? ''
          : !this.$v.zip.numeric
          ? 'Should contain only numbers'
          : !this.$v.zip.minLength || !this.$v.zip.maxLength
          ? 'Zip code should be 5 characters long'
          : 'This field is required',
        visaStatus: 'This field is required',
        boardCertifications: 'This field is required',
        ethnicity: 'This field is required',
        licensedStates : 'This field is required'
      };
    },
    societyId: function () {
      return this.user && this.user.society && this.user.society_id;
    },
    visaStatusOptions: function () {
      return Object.keys(VISA_STATUSES_LABELS).map((key) => ({
        value: key,
        text: VISA_STATUSES_LABELS[key],
      }));
    },
    getStateOptions: function () {
      return Object.keys(states.states).map(key => ({
        value: parseInt(key),
        text: states.states[key]
    }));
      
    },
    excludedCertificationIds: function () {
      return this.boardCertifications.map((bc) => parseInt(bc.id));
    },
    supportedFields: function () {
      if (!this.user || !this.user.society_membership_type_id) return [];
      return this.$store.getters.getMembershipTypesSupportedFields(
          this.user.society_membership_type_id
      );
    },
    memberTypeMappingName: function () {
      if (!this.user || !this.user.society_member_type_mapping_id) return '';
      return this.$store.getters.getMemberTypeMappingName(
          this.user.society_member_type_mapping_id
      );
    },
    userIsMSSUser: function () {
      return this.$store.getters.userIsMSSUser;
    },
    userIsNonMSSUser: function () {
      return this.$store.getters.userIsNonMSSUser;
    },
  },
  methods: {
    cancel: function () {
      this.$emit('profileFormCancel');
    },
    validateUsername() {
      // You can add additional validation logic here
      if (this.username.length >= 8) {
        return true;
      } else {
        alert(this.username.length);
        // Display an error message or handle validation accordingly
      }
    },
    validateState: function (name) {
      const {$dirty, $error} = this.$v[name];
      return $dirty ? !$error : null;
    },
    validateZipState: function () {
      if (!this.zip && !this.isFieldRequiredByMembership('practice_zip')) {
        return null;
      }
      const {$dirty, $error} = this.$v['zip'];
      return $dirty ? !$error : null;
    },
    onSubmit: async function () {
      this.$v.$touch();
      if (this.$v.$anyError) {
        this.$emit('validate-failed');
        return;
      }
      let updatedUser = {
        ...this.user,
        ethnicity: [this.ethnicity],
        gender_identity: this.genderIdentity,
        licensed_states : this.licensedStates ,
        visa_status: this.visaStatus,
        practice_zip:this.zip
      };
      if (this.isFieldSupported('boardCertifications')) {
        updatedUser.has_board_certification = this.hasBoardCertification;
        updatedUser.boardCertifications = this.boardCertifications;
      }
      this.$emit('profileFormSubmit', updatedUser);
    },
    onAddBoardCertification: function (certification) {
      this.boardCertifications.push(certification);
    },
    isFieldSupported: function (field) {
      return (
          this.supportedFields &&
          Array.isArray(this.supportedFields.supported_fields) &&
          this.supportedFields.supported_fields.includes(field)
      );
    },
    isFieldRequiredByMembership: function (field) {
      return (
          this.supportedFields &&
          Array.isArray(this.supportedFields.profile_required_fields) &&
          this.supportedFields.profile_required_fields.includes(field)
      );
    },
    onUpdateHasBoardCertification: function (value) {
      if (!value) {
        this.boardCertifications = [];
      }
      this.hasBoardCertification = value;
    },
    onZipInput: function (value, keyUpdater) {
      const zip = !value
          ? 0
          : value.length > 5
              ? value.slice(value.length - 5)
              : value;
      const intZip = parseInt(zip);
      this.$set(this.$v.zip, '$model', intZip.toString().padStart(5, '0'));
      keyUpdater();
      this.$nextTick(() => {
        this.$refs.zipInput.focus();
      });
    },
  },
  watch: {
    supportedFields: function () {
      //this.setDefaultSpecialty();
    },
  },
};
</script>

<style scoped>
@media (max-width: 768px) {
  .text-center-mobile {
    text-align: center;
    margin-bottom: 0.75rem;
  }

  .grey-box {
    padding: 1.5rem !important;
  }

  .p-sm-2 {
    padding: 0.75rem !important;
  }

  .phairify-select-wrapper {
    min-width: unset !important;
  }

  .mobile-buttons-profile {
    justify-content: center !important;
  }
}
</style>

<style lang="scss" scoped>
@import '../../../../../sass/v3';

.phairify-select-wrapper {
  min-width: 215px;
  width: 100%;

  &:after {
    font-size: 22px;
    right: 10px;
  }

  .custom-select {
    height: 100%;
    padding: 15px;
  }
}

.invalid-feedback {
  width: 100%;
  margin-top: 0.25rem;
  font-size: 80%;
  color: #dc3545;
  display: block;
}

.grey-box {
  border: none;
  border-radius: 0;
  background-color: rgba($v3_color_black_knight, 0.025);
  padding: 4rem;
}
</style>
